import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const smsConfigurationDetails = createAsyncThunk('sms_configuration/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `sms_setup/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addSmsConfiguration = createAsyncThunk('sms_configuration/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'sms_setup',
            data: {
                premise_id: data?.values?.premise,
                provider_name: data?.values?.providerName,
                api_url: data?.values?.apiUrl,
                api_key: data?.values?.apiKey,
                api_secret: data?.values?.apiSecret,
                sender_id: data?.values?.senderId,
                sender_name: data?.values?.senderName,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const smsConfiguration = createSlice({
    name: 'sms_configuration',
    initialState: {
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(smsConfigurationDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default smsConfiguration.reducer;